// components/StudentPortal/Home/StudentHomeVR.js
// Home "Hoy" optimizada para VR (S1-VR, F8). En VR el alumno NO escribe: solo
// VISIONA la sala activa que abre el profesor en el itinerario. Por eso aqui no
// hay tareas ni asistente; unicamente la sala activa (o un aviso si aun no se ha
// abierto). Las escenas se abren en la MISMA pestana (en Quest, una pestana
// nueva saca al alumno del contexto). Reutiliza el mismo hook que la pantalla.
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useStudentHome } from "./useStudentHome";
import styles from "./StudentHomeVR.module.scss";

export function StudentHomeVR() {
  const { t } = useTranslation("students");
  const {
    loading,
    error,
    student,
    activeScene,
    reload,
    resolveEnterUrl,
    trackSceneOpen,
  } = useStudentHome();
  const [entering, setEntering] = useState(false);
  const [enterError, setEnterError] = useState(null);

  // En VR: misma pestana. La URL la da el servidor (sala viva, ver
  // resolveEnterUrl). La baliza va con keepalive para que sobreviva a la
  // navegacion inmediata.
  const enterScene = async () => {
    if (!activeScene || entering) return;
    setEnterError(null);
    setEntering(true);
    try {
      const url = await resolveEnterUrl();
      if (!url) throw new Error("sin-url");
      trackSceneOpen(url);
      window.location.href = url;
    } catch (e) {
      if (e?.code === "no-active-scene") reload();
      else setEnterError(e?.code === "busy" ? "busy" : "generic");
      setEntering(false);
    }
  };

  if (loading)
    return <div className={styles.state}>{t("newHome.loading")}</div>;
  if (error === "no-student")
    return <div className={styles.state}>{t("newHome.noStudent")}</div>;
  if (error)
    return (
      <div className={styles.state}>
        {t("newHome.error")}{" "}
        <button type="button" className={styles.linkBtn} onClick={reload}>
          {t("newHome.retry")}
        </button>
      </div>
    );

  return (
    <div className={styles.vrHome}>
      <h1 className={styles.hello}>
        {t("newHome.greeting", { name: student?.name || "" })}
      </h1>
      <p className={styles.sub}>{student?.classnumber || ""}</p>

      {activeScene ? (
        <button
          type="button"
          className={styles.heroCard}
          onClick={enterScene}
          disabled={entering}
        >
          <span className={`${styles.pill} ${styles.pillGreen}`}>
            {t("newHome.activeScene")}
          </span>
          <span className={styles.heroTitle}>{activeScene.title}</span>
          {activeScene.category ? (
            <span className={styles.heroMeta}>{activeScene.category}</span>
          ) : null}
          <span className={styles.heroCta}>
            {entering ? t("newHome.enteringScene") : t("newHome.enterScene")}
          </span>
          {enterError ? (
            <span className={styles.heroError} role="alert">
              {enterError === "busy"
                ? t("newHome.enterErrorBusy")
                : t("newHome.enterErrorGeneric")}
            </span>
          ) : null}
        </button>
      ) : (
        <div className={`${styles.heroCard} ${styles.noRoom}`}>
          <span className={styles.vrIcon} aria-hidden="true">
            🥽
          </span>
          <span className={styles.heroTitle}>{t("newHome.vrNoRoomTitle")}</span>
          <span className={styles.heroMeta}>{t("newHome.vrNoRoomText")}</span>
        </div>
      )}
    </div>
  );
}
